import { NavigationGuardNext, RouteLocationNormalized } from "vue-router";
import { hasPlanAccess } from "@/shared/utils/plan.utils";

export default async (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext,
): Promise<void> => {
  if (to.matched.some((record) => record.meta.skipMerchantGuards)) {
    next();
    return;
  }

  if (hasPlanAccess(to)) {
    next();
  } else {
    next({ name: "dashboard" });
  }
};
